<template>
  <div>
    <v-card>
      <v-toolbar card prominent top offet-y v-bind:class="{'fixedToolbar' : !drawer}" style="z-index: 2;">
        <v-toolbar-title class="headline grey-text">Edit Transaction</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="editTransactionCheck($v.editTransaction)">
          <v-icon color="green">fas fa-check</v-icon>
        </v-btn>
        <v-btn icon @click.native="$router.push({ path: '/dashboard/transaction' })">
          <v-icon color="red">fas fa-times</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text>
        <v-container v-bind:class="{'padContent': !drawer}" grid-list-md>
          <v-layout wrap>
            <v-flex xs12 md6>
              <v-btn-toggle mandatory v-model="editTransaction.transactionType" style="width: 100%; margin-top: 15px;">
                <v-btn flat color="blue" value="income" style="width: 33.33%">
                  Income
                </v-btn>
                <v-btn flat color="blue" value="expense" style="width: 33.33%">
                  Expense
                </v-btn>
                <v-btn flat color="blue" value="transfer" style="width: 33.33%">
                  Transfer
                </v-btn>
              </v-btn-toggle>
            </v-flex>
            <v-flex xs12 md6>
              <v-select v-bind:items="currency"
                        label="Currency"
                        v-model="editTransaction.currency"
                        :error-messages="currencyErrors"
                        @input="$v.editTransaction.currency.$touch()"
                        @blur="$v.editTransaction.currency.$touch()"
                        @change="selectedCurrencyChanged"></v-select>
            </v-flex>
            <v-flex xs12 v-if="convert">
              <v-expansion-panel popout>
                <v-expansion-panel-content>
                  <div slot="header"><b>Conversion Rates</b></div>
                  <v-card>
                    <v-card-text>
                      <v-layout wrap>

                        <v-list two-line>
                          <template v-for="item in conversions">
                            <v-divider></v-divider>
                            <v-list-tile :key="item.title">
                              <v-list-tile-content>
                                <v-list-tile-title v-html="item.convertFrom"></v-list-tile-title>
                                <v-list-tile-sub-title v-html="item.convertTo"></v-list-tile-sub-title>
                              </v-list-tile-content>
                            </v-list-tile>
                          </template>
                        </v-list>

                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-flex>
            <v-flex xs12>
              <v-text-field v-model="editTransaction.transactionName"
                            label="Transaction Name"
                            :error-messages="transactionNameErrors"
                            @input="$v.editTransaction.transactionName.$touch()"
                            @blur="$v.editTransaction.transactionName.$touch()"></v-text-field>
            </v-flex>
            <v-flex xs12 v-if="editTransaction.transactionType !== 'transfer'">
              <v-autocomplete label="Account"
                              :items="account"
                              v-model="editTransaction.account"
                              item-text="accountName"
                              item-value="accountName"
                              chips
                              prepend-icon="fas fa-university"
                              hint="What Account does this belong to?"
                              persistent-hint
                              :change="adjustAccountToMatchBudget"
                              :error-messages="accountErrors"
                              @input="$v.editTransaction.account.$touch()"
                              @blur="$v.editTransaction.account.$touch()"
                              max-height="auto">
                <template slot="selection" slot-scope="data">
                  <v-chip @input="data.parent.selectItem(data.item)"
                          :selected="data.selected"
                          class="chip--select-multi"
                          :key="JSON.stringify(data.item)">

                    {{ data.item.accountName }}
                  </v-chip>
                </template>
                <template slot="item" slot-scope="data">
                  <template v-if="typeof data.item !== 'object'">
                    <v-list-tile-content v-text="data.item"></v-list-tile-content>
                  </template>
                  <template v-else>
                    <v-list-tile-content>
                      <v-list-tile-title v-text="data.item.accountName"></v-list-tile-title>
                    </v-list-tile-content>
                  </template>
                </template>
              </v-autocomplete>
            </v-flex>
            <v-flex xs12 v-if="editTransaction.transactionType === 'expense'">
              <v-autocomplete label="Budget"
                              :items="budget"
                              v-model="editTransaction.budget"
                              chips
                              prepend-icon="fa-money-bill-alt"
                              hint="What Budget does this belong to?"
                              persistent-hint
                              :change="selectAndHideAccount"></v-autocomplete>
            </v-flex>
            <v-flex xs12 v-if="editTransaction.transactionType === 'transfer'">
              <v-autocomplete :items="transferAccount"
                              v-model="editTransaction.transferFrom"
                              label="Transfer From Account"
                              item-text="accountName"
                              item-value="accountName"
                              chips
                              prepend-icon="fa-balance-scale"
                              hint="Transfer from Account?"
                              persistent-hint
                              :error-messages="transferFromErrors"
                              @input="$v.editTransaction.transferFrom.$touch()"
                              @blur="$v.editTransaction.transferFrom.$touch()"
                              max-height="auto" autocomplete>
                <template slot="selection" slot-scope="data">
                  <v-chip @input="data.parent.selectItem(data.item)"
                          :selected="data.selected"
                          class="chip--select-multi"
                          :key="JSON.stringify(data.item)">

                    {{ data.item.accountName }}
                  </v-chip>
                </template>
                <template slot="item" slot-scope="data">
                  <template v-if="typeof data.item !== 'object'">
                    <v-list-tile-content v-text="data.item"></v-list-tile-content>
                  </template>
                  <template v-else>

                    <v-list-tile-content>
                      <v-list-tile-title v-text="data.item.accountName"></v-list-tile-title>

                    </v-list-tile-content>
                  </template>
                </template>
              </v-autocomplete>
            </v-flex>
            <v-flex xs12 v-if="editTransaction.transactionType === 'transfer'">
              <v-autocomplete :items="transferAccount"
                              v-model="editTransaction.transferTo"
                              label="Transfer To Account"
                              item-text="accountName"
                              item-value="accountName"
                              chips
                              prepend-icon="fa-balance-scale"
                              hint="Transfer To Account?"
                              persistent-hint
                              :error-messages="transferToErrors"
                              @input="$v.editTransaction.transferTo.$touch()"
                              @blur="$v.editTransaction.transferTo.$touch()"
                              max-height="auto">
                <template slot="selection" slot-scope="data">
                  <v-chip @input="data.parent.selectItem(data.item)"
                          :selected="data.selected"
                          class="chip--select-multi"
                          :key="JSON.stringify(data.item)">

                    {{ data.item.accountName }}
                  </v-chip>
                </template>
                <template slot="item" slot-scope="data">
                  <template v-if="typeof data.item !== 'object'">
                    <v-list-tile-content v-text="data.item"></v-list-tile-content>
                  </template>
                  <template v-else>

                    <v-list-tile-content>
                      <v-list-tile-title v-text="data.item.accountName"></v-list-tile-title>
                    </v-list-tile-content>
                  </template>
                </template>
              </v-autocomplete>
            </v-flex>
            <v-flex xs12>
              <v-autocomplete :items="category"
                              v-model="editTransaction.category"
                              label="Category"
                              chips
                              prepend-icon="fa-tags"
                              hint="What Category does this belong to?"
                              persistent-hint
                              :error-messages="categoryErrors"
                              @input="$v.editTransaction.category.$touch()"
                              @blur="$v.editTransaction.category.$touch()"></v-autocomplete>
            </v-flex>
            <v-flex xs12 v-if="editTransaction.transactionType === 'expense'">
              <v-expansion-panel popout style="padding: 5px 0;">
                <v-expansion-panel-content>
                  <div slot="header"><b>Items</b></div>
                  <v-card>
                    <v-card-text>
                      <v-layout wrap>
                        <v-flex xs8>
                          <v-text-field append-icon="search"
                                        label="Search"
                                        single-line
                                        hide-details
                                        v-model="transactionItemsSearch"></v-text-field>
                        </v-flex>
                        <v-flex xs4>
                          <v-tooltip bottom>
                            <v-btn v-on:click.prevent="addItem = true"
                                   slot="activator"
                                   dark
                                   small
                                   fab
                                   middle
                                   right
                                   color="red" style="float:right;">
                              <v-icon>add</v-icon>
                            </v-btn>
                            <span>Add Item</span>
                          </v-tooltip>
                        </v-flex>
                      </v-layout>
                      <v-divider></v-divider>
                      <v-data-table :headers="transactionItemheaders"
                                    :items="editTransaction.items"
                                    hide-actions
                                    item-key="itemName"
                                    :search="transactionItemsSearch">
                        <template slot="items" slot-scope="props">
                          <tr @click="props.expanded = !props.expanded">
                            <td>{{ props.item.itemName }}</td>
                            <td>{{ props.item.itemPrice }}</td>
                          </tr>
                        </template>
                        <v-alert slot="no-results" :value="true" color="error" icon="warning">
                          No results found for search "{{ transactionItemsSearch }}" .
                        </v-alert>
                        <template slot="expand" slot-scope="props">
                          <v-card flat>
                            <v-divider></v-divider>
                            <v-layout>
                              <v-flex xs6><v-btn color="warning" v-on:click.prevent="EditItem(props.item)"><v-icon style="font-size:18px; padding-right: 5px;">fa-edit</v-icon>Edit</v-btn></v-flex>
                              <v-flex xs6><v-btn color="error" v-on:click.prevent="DeleteItem(props.item)"><v-icon style="font-size:18px; padding-right: 5px;">fa-trash</v-icon>Delete</v-btn></v-flex>
                            </v-layout>
                            <v-divider></v-divider>
                            <table style="width: 100%;">
                              <tr>
                                <td><v-subheader>Currency:</v-subheader></td>
                                <td><v-subheader>{{ props.item.itemCurrency }}</v-subheader></td>
                              </tr>
                              <tr>
                                <td><v-subheader>Category:</v-subheader></td>
                                <td><v-subheader>{{  }}</v-subheader></td>
                              </tr>
                              <tr v-if="props.item.isTaxed">
                                <td><v-subheader>Total With Tax:</v-subheader></td>
                                <td><v-subheader>{{ props.item.taxedPrice }}</v-subheader></td>
                              </tr>

                            </table>
                            <!--<v-card-text>Peek-a-boo!</v-card-text>-->
                          </v-card>
                        </template>
                      </v-data-table>
                    </v-card-text>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-flex>
            <v-flex xs12>
              <v-text-field label="Transaction Amount" prepend-icon="fa-money-bill-alt" type="number" min="1"
                            v-model="editTransaction.transactionAmount"
                            :error-messages="transactionAmountErrors"
                            @input="$v.editTransaction.transactionAmount.$touch()"
                            @blur="$v.editTransaction.transactionAmount.$touch()"></v-text-field>

            </v-flex>
            <v-flex xs12>
              <v-text-field label="Comment" prepend-icon="fa-comment" v-model="editTransaction.comment"></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-switch v-model="editTransaction.recurringTransaction"
                        label="Recurring Transaction"></v-switch>
            </v-flex>
            <v-flex xs12 v-if="editTransaction.recurringTransaction">
              <v-layout wrap>
                <v-flex xs6>
                  <v-text-field label="Repeat Every" type="number" min="1" max="60" v-model="editTransaction.repeat"></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-select v-model="editTransaction.cycle"
                            :items="['Day','Week','Month','Year']"></v-select>
                </v-flex>
              </v-layout>
              <v-radio-group v-model="editTransaction.period" row>
                <v-radio label="Forever" value="Forever"></v-radio>
                <v-radio label="For Number of cycles" value="For"></v-radio>
              </v-radio-group>
              <v-text-field v-if="editTransaction.period === 'For'" label="Number of cycles" type="number" min="1" max="60" v-model="editTransaction.numberOfCycles"></v-text-field>

              <v-dialog ref="goesOff"
                        persistent
                        lazy
                        v-model="editModelGoesOff"
                        full-width
                        width="290px"
                        :return-value.sync="editTransaction.goesOffFirst">
                <v-text-field slot="activator"
                              label="Start Date"
                              v-model="editTransaction.goesOffFirst"
                              prepend-icon="event"
                              readonly></v-text-field>
                <v-date-picker v-model="editTransaction.goesOffFirst" scrollable>
                  <v-spacer></v-spacer>
                  <v-btn flat color="primary" @click="editModelGoesOff = false">Cancel</v-btn>
                  <v-btn flat color="primary" @click="$refs.goesOff.save(editTransaction.goesOffFirst)">OK</v-btn>
                </v-date-picker>
              </v-dialog>
            </v-flex>
            <v-flex xs6 v-if="!editTransaction.recurringTransaction">
              <v-menu ref="datemenu"
                      lazy
                      :close-on-content-click="false"
                      v-model="datemenu"
                      transition="scale-transition"
                      offset-y
                      full-width
                      :nudge-right="40"
                      min-width="290px"
                      :return-value.sync="editTransaction.transactionDate">
                <v-text-field slot="activator"
                              label="Date Picker"
                              v-model="editTransaction.transactionDate"
                              prepend-icon="fa-calendar"
                              readonly></v-text-field>
                <v-date-picker v-model="editTransaction.transactionDate" no-title scrollable>
                  <v-spacer></v-spacer>
                  <v-btn flat color="primary" @click="datemenu = false">Cancel</v-btn>
                  <v-btn flat color="primary" @click="$refs.datemenu.save(editTransaction.transactionDate)">OK</v-btn>
                </v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs6 v-if="!editTransaction.recurringTransaction">
              <v-dialog ref="timemenu"
                        persistent
                        v-model="timemenuvisibilty"
                        lazy
                        full-width
                        width="290px"
                        :return-value.sync="editTransaction.transactionTime">
                <v-text-field slot="activator"
                              label="Time Picker"
                              v-model="editTransaction.transactionTime"
                              prepend-icon="access_time"
                              readonly></v-text-field>
                <v-time-picker v-model="editTransaction.transactionTime" actions>
                  <v-spacer></v-spacer>
                  <v-btn flat color="primary" @click="timemenuvisibilty = false">Cancel</v-btn>
                  <v-btn flat color="primary" @click="$refs.timemenu.save(editTransaction.transactionTime)">OK</v-btn>
                </v-time-picker>
              </v-dialog>
            </v-flex>
            <v-flex xs12>
              <v-select v-bind:items="paymentType"
                        v-model="editTransaction.paymentType"
                        label="Payment Type"
                        chips
                        :error-messages="paymentTypeErrors"
                        @input="$v.editTransaction.paymentType.$touch()"
                        @blur="$v.editTransaction.paymentType.$touch()"></v-select>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>

    </v-card>

    <!-- Add Item to Transaction Dialog Box -->
    <v-layout row justify-center>
      <v-dialog v-model="addItem" persistent scrollable max-width="500px">
        <v-card>
          <v-card-title>
            <span class="headline">New Item</span>
            <v-spacer></v-spacer>
            <v-btn icon @click.native="addItemCheck($v.transactionItemTemp)">
              <v-icon color="green">fas fa-check</v-icon>
            </v-btn>
            <v-btn icon @click.native="addItem = false">
              <v-icon color="red">fas fa-times</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>

                  <v-combobox v-model="transactionItemTemp.itemName"
                              :items="transactionItemsNames"
                              chips
                              label="Item Name"></v-combobox>

                  <!--<v-combobox label="Item Name"
                            v-model="transactionItemTemp.itemName"
                            :error-messages="transactionItemNameErrors"
                            @input="$v.transactionItemTemp.itemName.$touch()"
                            @blur="$v.transactionItemTemp.itemName.$touch()"
                            chips
                            :items="transactionItemsNames">-->
                  <!--<template slot="selection" slot-scope="data">
                <v-chip @input="data.parent.selectItem(data.item)"
                        class="chip--select-multi"
                        :selected="data.selected"
                        :disabled="data.disabled"
                        :key="JSON.stringify(data.item)">-->
                  <!--<v-avatar class="accent">{{ data.item.slice(0, 1).toUpperCase() }}</v-avatar>-->
                  <!--{{ data.item }}
                  </v-chip>
                </template>-->
                  <!--</v-combobox>-->
                </v-flex>
                <v-flex xs6>
                  <v-text-field label="Item Price" type="number" min="1"
                                v-model="transactionItemTemp.itemPrice"
                                :error-messages="transactionItemPriceErrors"
                                @input="$v.transactionItemTemp.itemPrice.$touch()"
                                @blur="$v.transactionItemTemp.itemPrice.$touch()"></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-select v-bind:items="currency"
                            label="Currency"
                            v-model="transactionItemTemp.itemCurrency"
                            single-line
                            :error-messages="transactionItemCurrencyErrors"
                            @input="$v.transactionItemTemp.itemCurrency.$touch()"
                            @blur="$v.transactionItemTemp.itemCurrency.$touch()"></v-select>
                </v-flex>
                <v-flex xs12>
                  <v-checkbox label="Add Tax to item?"
                              v-model="transactionItemTemp.isTaxed"></v-checkbox>
                </v-flex>
                <v-flex xs12 v-if="transactionItemTemp.isTaxed">
                  <v-text-field label="Total WIth Tax" type="number"
                                v-model="transactionItemTemp.taxedPrice"></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

        </v-card>
      </v-dialog>
    </v-layout>
    <!-- End Of Add Item to Transaction Dialog Box -->

  </div>
</template>


<script>
  import { validationMixin } from 'vuelidate'
  import { required, minValue } from 'vuelidate/lib/validators'

  import { globalFunctions } from '../../javascript/globalFunctions'
  import { transactionManager } from '../../javascript/transactionManager'

  export default {
    mixins: [validationMixin],
    props: ['drawer'],
    data() {
      return {
        showSnackbar: false,
        snackbarText: '',
        snackbarColor: '',
        addItem: false,
        datemenu: false,
        timemenuvisibilty: false,
        editModelGoesOff: false,
        transactionItemheaders: [
          { text: 'Item', align: 'left', value: 'itemName' },
          { text: 'Price', align: 'left', value: 'itemPrice' }
        ],
        transactionItems: [],
        transactionItemsNames: ['Cat', 'Dog'],
        transactionItemsSearch: '',
        currency: ["JMD", "USD"],
        account: [],
        budget: ["None"],
        transferAccount: [],
        selectedAccount: '',
        category: ["cat1", "cat2", "cat3", "cat4"],
        paymentType: ["Cash", "Credit Card", "Debit Card", "Bank Transfer", "Voucher"],
        editTransaction: {
          id: 0,
          account: '',
          transactionName: '',
          transactionType: 'expense',
          transactionAmount: 0,
          paymentType: '',
          budget: 'None',
          comment: '',
          category: '',
          currency: '',
          items: [],

          transactionDate: '',
          transactionTime: null,

          transferFrom: '',
          transferTo: '',

          recurringTransaction: false,

          //Recurring Transactions
          repeat: 1,
          cycle: '',
          period: 'Forever',
          numberOfCycles: 1,
          goesOffFirst: '',

          //State of Current Object
          objectState: 'New',
          show: false
        },
        transactionItemTemp: {
          itemName: [],
          itemPrice: '',
          itemCurrency: '',
          isTaxed: false,
          taxedPrice: '',

          dateChanged: ''
        },
        transactionType: 1,
        conversions: [],
        currencyConversions: [],
        convert: false,
        transactions: []
      }
    },
    computed: {
      transactionNameErrors() {
        const errors = []
        if (!this.$v.editTransaction.transactionName.$dirty) return errors
        !this.$v.editTransaction.transactionName.required && errors.push('Transaction Name is required')
        return errors
      },
      accountErrors() {
        const errors = []
        if (!this.$v.editTransaction.account.$dirty) return errors
        !this.$v.editTransaction.account.required && errors.push('Account is required')
        return errors
      },
      transferFromErrors() {
        const errors = []
        if (!this.$v.editTransaction.transferFrom.$dirty) return errors
        !this.$v.editTransaction.transferFrom.required && errors.push('Tranfer from is required')
        return errors
      },
      transferToErrors() {
        const errors = []
        if (!this.$v.editTransaction.transferTo.$dirty) return errors
        !this.$v.editTransaction.transferTo.required && errors.push('Tranfer to is required')
        if (this.editTransaction.transferTo === this.editTransaction.transferFrom) errors.push('Cannot tranfer to the same Account')
        return errors
      },
      paymentTypeErrors() {
        const errors = []
        if (!this.$v.editTransaction.paymentType.$dirty) return errors
        !this.$v.editTransaction.paymentType.required && errors.push('Payment Type is required')
        return errors
      },
      categoryErrors() {
        const errors = []
        if (!this.$v.editTransaction.category.$dirty) return errors
        !this.$v.editTransaction.category.required && errors.push('Category is required')
        return errors
      },
      transactionAmountErrors() {
        const errors = []
        if (!this.$v.editTransaction.transactionAmount.$dirty) return errors
        !this.$v.editTransaction.transactionAmount.minValue && errors.push('Transaction Amount must be at least 1')
        return errors
      },
      currencyErrors() {
        const errors = []
        if (!this.$v.editTransaction.currency.$dirty) return errors
        !this.$v.editTransaction.currency.required && errors.push('Currency is required')
        return errors
      },
      transactionItemNameErrors() {
        const errors = []
        if (!this.$v.transactionItemTemp.itemName.$dirty) return errors
        !this.$v.transactionItemTemp.itemName.required && errors.push('Item Name is required')
        return errors
      },
      transactionItemPriceErrors() {
        const errors = []
        if (!this.$v.transactionItemTemp.itemPrice.$dirty) return errors
        !this.$v.transactionItemTemp.itemPrice.minValue && errors.push('Item Price must be at least 1')
        return errors
      },
      transactionItemCurrencyErrors() {
        const errors = []
        if (!this.$v.transactionItemTemp.itemCurrency.$dirty) return errors
        !this.$v.transactionItemTemp.itemCurrency.required && errors.push('Currency is required')
        return errors
      },
      selectAndHideAccount() {
        //Find Correct Budget Object
        let bud = this.$store.state.Budgets
        for (let i = 0; i < bud.length; i++) {
          if (bud[i].budgetName === this.editTransaction.budget) {
            this.editTransaction.account = bud[i].account
            //this.accountReadonly = true
          }
          //else if (this.editTransaction.budget === "None") {
          //this.accountReadonly = false
          //}
        }
      },
      adjustAccountToMatchBudget() {

        ////////////////////////////////////////////////////////
        //TODO: Check if Budget is not "None".
        //TODO: Show error and choice to user if not none
        //and account changed
        ////////////////////////////////////////////////////////

      }
    },
    methods: {
      //updateDateAndTime: function () {
      //  this.editTransaction.transactionDate = globalFunctions.getCurrentDateForPicker()
      //  this.editTransaction.transactionTime = globalFunctions.getCurrentTimeForPicker()
      //},
      buildAccountSelect: function () {
        let tempAccount = this.$store.state.Accounts

        this.account.push({ header: 'Accounts' })

        for (let i = 0; i < tempAccount.length; i++) {
          this.account.push(tempAccount[i])
        }

        this.transferAccount = this.account

        //let group = this.$store.state.Groups

        //if (group.length > 0) {
        //  this.account.push({ header: 'Groups' })

        //  for (let i = 0; i < group.length; i++) {
        //    this.account.push(group[i])
        //  }
        //}

      },
      TransactionCheck: function ($v) {
        $v.$touch(); //Triggers Error Messages

        if (this.editTransaction.transactionAmount < 0 || !globalFunctions.isIntOrFloat(this.editTransaction.transactionAmount) || this.editTransaction.transactionAmount === "") { this.editTransaction.transactionAmount = 0 }

        if (this.editTransaction.transactionType !== 'transfer') {
          if ($v.account.$invalid || $v.category.$invalid || $v.transactionAmount.$invalid || $v.currency.$invalid || $v.paymentType.$invalid) {
            return false
          }
        }
        else if (this.editTransaction.transactionType === 'transfer') {
          if ($v.transferFrom.$invalid || $v.transferTo.$invalid || $v.category.$invalid || $v.transactionAmount.$invalid || $v.currency.$invalid || $v.paymentType.$invalid) {
            return false
          }
        }
        return true
      },
      editTransactionCheck: function ($v) {
        if (this.TransactionCheck($v)) {
          transactionManager.updateEditedTransaction(this.editTransaction)
          

          //////////////////////////////////////
          //Transaction Successful
          //////////////////////////////////////

          //this.snackbarText = "Transaction Successful"
          //this.snackbarColor = "success"
          //this.showSnackbar = true

          this.$router.push({ path: '/dashboard/transaction' })
        }
      },
      editTransactionSetter: function (item) {
        for (let i = 0; i < this.transactions.length; i++) {
          if (this.transactions[i].id === parseInt(item)) {
            let editEntry = JSON.parse(JSON.stringify(this.transactions[i]))
            this.editTransaction = editEntry
            break
          }
        }
      },
      itemCheck: function ($v) {
        $v.$touch(); //Triggers Error Messages

        if (this.transactionItemTemp.itemPrice < 0 || !globalFunctions.isIntOrFloat(this.transactionItemTemp.itemPrice) || this.transactionItemTemp.itemPrice === "") { this.transactionItemTemp.itemPrice = 0 }

        if ($v.itemName.$invalid || $v.itemPrice.$invalid || $v.itemCurrency.$invalid) {
          return false
        }
        return true
      },
      addItemCheck: function ($v) {
        if (this.itemCheck($v)) {
          this.addItemToTransaction()
        }
      },
      addItemToTransaction: function () {
        //Add Item to Transaction Items

        let newItem = JSON.parse(JSON.stringify(this.transactionItemTemp))

        this.editTransaction.items.push(newItem)

        this.addItem = false

        this.doesItemExist()

        this.addItemPriceToTransactionAmount()

        this.resetItemForm()

      },
      addItemPriceToTransactionAmount: function () {

        let total = 0;
        for (let i = 0; i < this.editTransaction.items.length; i++) {
          total = parseFloat(total) + parseFloat(this.currencyConverter(this.editTransaction.items[i]))
        }

        this.editTransaction.transactionAmount = total

      },
      resetItemForm: function () {
        this.transactionItemTemp.itemName = ''
        this.transactionItemTemp.itemPrice = 0
        this.transactionItemTemp.itemCurrency = ''
        this.transactionItemTemp.isTaxed = false
        this.transactionItemTemp.taxedPrice = 0

      },
      doesItemExist: function () {
        if (this.transactionItems.length !== 0) {
          for (let i = 0; i < this.transactionItems.length; i++) {
            if (this.transactionItems[i].itemName === this.transactionItemTemp.itemName) {

              /////////////////////////////////////////////////////////////
              //Check All other values to see if they are the same
              /////////////////////////////////////////////////////////////

              if (this.transactionItems[i].itemPrice !== this.transactionItemTemp.itemPrice) {

                ///////////////////////////////////////////////////////////////////
                //Create New Item To Represent Update,
                //Keep Old Data As To Not Cause Problems To Pass Transactions
                ///////////////////////////////////////////////////////////////////

                this.addNewItem()
                return
              }

            }
          }
        } else {
          this.addNewItem()
        }

      },
      addNewItem: function () {
        this.transactionItemTemp.dateChanged = globalFunctions.getCurrentDate()

        let newEntry = JSON.parse(JSON.stringify(this.transactionItemTemp))

        newEntry.id = this.getLargestIdFromTransactionItems() + 1

        this.$store.commit('addNewItemToStore', newEntry)
      },
      getLargestIdFromTransactionItems: function () {
        let largest = 0
        for (let i = 0; i < this.transactionItems.length; i++) {
          if (this.transactionItems[i].id > largest) {
            largest = this.transactionItems[i].id
          }
        }
        return largest
      },
      selectedCurrencyChanged: function () {
        ///////////////////////////////////////////////////////
        //Go Through Each Transaction Item 
        ///////////////////////////////////////////////////////

        for (let i = 0; i < this.transactionItems.length; i++) {
          ////////////////////////////////////////////////////////////////
          //Loop conversions and test if currency already found
          ///////////////////////////////////////////////////////////////

          for (let x = 0; x < this.conversions.length; x++) {
            if (this.transactionItems[i].itemCurrency === this.conversions[x]) {
              break
            } else if (x === this.conversions.length - 1) {
              this.getConversion(this.transactionItems[i].itemCurrency)
            }
          }
        }
      },
      getConversion: function (from) {
        for (let i = 0; i < this.currencyConversions.length; i++) {
          if (this.currencyConversions[i].convertFrom === from && this.currencyConversions[i].convertTo === this.editTransaction.currency) {
            this.conversions.push(this.currencyConversions[i])
          }
        }

        this.convert = true
      },
      currencyConverter: function (item) {
        ////////////////////////////////////////////////////////////////////
        //Returns Price If Currencies Are The Same,
        //Returns Adjusted Price If Currency Is Different
        ////////////////////////////////////////////////////////////////////

        if (item.itemCurrency === this.editTransaction.currency || this.editTransaction.currency === "") {
          return item.itemPrice
        } else {
          for (let i = 0; i < this.conversions.length; i++) {
            if (this.conversions.convertFrom === item.itemCurrency) {
              return parseFloat(this.conversions.conversionRate) * item.itemPrice
            }
          }
        }

      }
    },
    beforeMount() {
      this.transactions = this.$store.state.Transactions

      let tranItems = this.$store.state.Items
      this.transactionItems = tranItems
      for (let i = 0; i < tranItems.length; i++) {
        this.transactionItemsNames.push(tranItems[i].itemName)
      }

      let cat = this.$store.state.Categories
      for (let i = 0; i < cat.length; i++) {
        this.category.push(cat[i].categoryName)
      }

      let cur = this.$store.state.Currencies
      for (let i = 0; i < cur.length; i++) {
        this.currency.push(cur[i].currencyName)
      }

      let curCon = this.$store.state.CurrencyConversions
      for (let i = 0; i < curCon.length; i++) {
        this.currencyConversions.push(curCon[i])
      }

      let bud = this.$store.state.Budgets
      for (let i = 0; i < bud.length; i++) {
        this.budget.push(bud[i].budgetName)
      }

      //this.updateDateAndTime()
      this.buildAccountSelect()

      this.editTransactionSetter(this.$route.params.itemId)
    },
    validations: {
      editTransaction: {
        transactionName: {
          required
        },
        account: {
          required
        },
        category: {
          required
        },
        transactionAmount: {
          required,
          minValue: minValue(1)
        },
        transactionDate: {
          required
        },
        transactionTime: {
          required
        },
        paymentType: {
          required
        },
        currency: {
          required
        },
        transferFrom: {
          required
        },
        transferTo: {
          required
        }
      },
      transactionItemTemp: {
        itemName: {
          required
        },
        itemPrice: {
          required,
          minValue: minValue(1)
        },
        itemCurrency: {
          required
        }

      }
    }


  }
</script>



// WEBPACK FOOTER //
// src/components/transaction/EditTransaction.vue